import { faMinus, faPlus } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useEffect, useState } from 'react';
import "../../../Css/Storefront.css";

export default function PlusMinusBtn ( { id, count, changeCount, setCount } )
{
    const [ qty, setQty ] = useState( 1 );

    useEffect( () =>
    {
        setCount( qty );
        if ( changeCount ) changeCount( id, qty );
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [ qty ] );

    useEffect( () =>
    {
        if ( count ) setQty( count );
    }, [ count ] );

    const handleInputChange = ( e ) =>
    {
        const value = parseInt( e.target.value, 10 );
        setQty( Number.isNaN( value ) || value < 0 ? 0 : value );
    };

    return (
        <div className="qty-control">
            <button
                type="button"
                className="qty-btn"
                onClick={ () => setQty( ( prev ) => Math.max( prev - 1, 0 ) ) }
            >
                <FontAwesomeIcon icon={ faMinus } />
            </button>

            <input
                type="number"
                className="qty-input"
                min={ 0 }
                max={ 100 }
                value={ qty }
                onChange={ handleInputChange }
            />

            <button
                type="button"
                className="qty-btn"
                onClick={ () => setQty( ( prev ) => prev + 1 ) }
            >
                <FontAwesomeIcon icon={ faPlus } />
            </button>
        </div>
    );
}
